import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { ContactUsViewModel } from '../../models';
import { ContactUsService } from '../../services';
import { FormsModule } from '@angular/forms';


const nextUrl = 'landowner/listing#welcome';
@Component({
    selector: 'contact-us-form',
    templateUrl: './contact-us-form.component.html',
    styleUrls: ['./contact-us-form.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class ContactUsFormComponent {

  @Input() campaignTag: string;

  model = {} as ContactUsViewModel;
  phoneValid = true;
  loading = false;
  submitted = false;

  constructor(
    readonly contactUsService: ContactUsService) { }

  onSubmit() {
    if (!this.model.email && !this.model.phone) {
      this.phoneValid = false;
    } else {
      this.phoneValid = true;
    }

    this.loading  = true;
    this.model.campaignTag = this.campaignTag;
    this.contactUsService.post(this.model).subscribe(() => {
      this.loading = false;
      this.submitted = true;
    });
  }

}
